/**
 * Quarter-circle wedge shown inside the step circle for the `Partial` state --
 * a step that has some content but isn't finished.
 *
 * Figma: `Step` / `StepAI` -> `Property 1=Partial` (node 8938:12 / 8938:47866).
 * The wedge is a 22px-diameter quadrant centred in the 28px circle, leaving a
 * 2px gap to the border. Colour comes from `currentColor` so the CSS module can
 * switch it between the default and required (red) treatments.
 */
export function StepperPartialIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M11 0A11 11 0 0 1 22 11H11Z" fill="currentColor" />
    </svg>
  );
}
